import Pager from '@/shared/pager/pager';

export default {
  build: () => {
    const keysToSearch = [
      'name',
      'lastName',
    ];

    const exportDefinitions = [
      { value: 'id', label: 'Id' },
      { value: 'name', label: 'Name' },
      { value: 'lastName', label: 'LastName' },
      { value: 'email', label: 'Email' },
      { value: 'phone', label: 'Phone' },
    ];

    return new Pager(keysToSearch, exportDefinitions);
  }
};



// WEBPACK FOOTER //
// ./src/entities/referee/referee-pager.js